import { render, staticRenderFns } from "./CustomerLead.vue?vue&type=template&id=5b350a2e&scoped=true&"
import script from "./CustomerLead.vue?vue&type=script&lang=js&"
export * from "./CustomerLead.vue?vue&type=script&lang=js&"
import style0 from "./CustomerLead.vue?vue&type=style&index=0&id=5b350a2e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b350a2e",
  null
  
)

export default component.exports